import React from "react";

export const CardSkeleton = () => {
  return (
    <div className="animate-pulse bg-white p-3 rounded-md flex shadow-sm flex-col gap-2">
      {/* Image Placeholder */}
      <div className="rounded-lg bg-gray-200 h-[113px] w-full"></div>
      
      {/* Category Placeholder */}
      <div className="bg-gray-200 w-20 h-4 rounded-md mt-2"></div>
      
      {/* Title Placeholder */}
      <div className="bg-gray-200 w-3/4 h-5 rounded-md mt-2"></div>
      
      {/* Tutor Info Placeholder */}
      <div className="flex justify-between mt-4">
        <div className="flex gap-2">
          <div className="w-6 h-6 bg-gray-200 rounded-full"></div>
          <div className="flex flex-col justify-between">
            <div className="bg-gray-200 w-16 h-4 rounded-md"></div>
            <div className="bg-gray-200 w-12 h-3 rounded-md mt-1"></div>
          </div>
        </div>
        {/* Button Placeholder */}
        <div className="w-20 h-8 bg-gray-200 rounded-md"></div>
      </div>
    </div>
  );
};
